import { Button, Form, Modal, Space, Typography, message } from "antd";
import { useEffect } from "react";
import { useLoading } from "../../context/loadingContext";
import CreateAdminMerchant from "../../functions/admin/createAdminMerchant";
import UpdateMerchant from "../../functions/admin/updateMerchant";
import MerchantAdminFormFields from "../admin/merchantAdminFormFields";
import { merchantToFormValues } from "../admin/merchantAdminConstants";
import { bg_button } from "constant/css";

const { Text } = Typography;

/**
 * Admin merchant create / edit — shared form and layout.
 * @param {"create"|"edit"} mode
 */
const AdminMerchantModal = ({
  mode = "create",
  open,
  close,
  merchant,
  refresh,
}) => {
  const [form] = Form.useForm();
  const { showLoading, hideLoading } = useLoading();
  const isCreate = mode === "create";

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue(merchantToFormValues(isCreate ? null : merchant));
  }, [open, isCreate, merchant, form]);

  const handleSubmit = async (values) => {
    showLoading();
    try {
      if (isCreate) {
        const response = await CreateAdminMerchant(values);
        hideLoading();
        if (!response?.success) {
          message.error(response?.message || "Мерчант үүсгэхэд алдаа гарлаа");
          return;
        }
        close();
        form.resetFields();
        refresh?.();
        Modal.success({
          title: "Мерчант амжилттай үүслээ",
          width: 480,
          content: (
            <Space direction="vertical" size="small" className="w-full">
              <Text>Доорх мэдээллийг хадгална уу.</Text>
              <div className="rounded-lg bg-gray-50 p-3 text-sm">
                <div>
                  <Text type="secondary">ID:</Text> {response.data?.id}
                </div>
                <div>
                  <Text type="secondary">Нэвтрэх нэр:</Text> {response.data?.email}
                </div>
                <div>
                  <Text type="secondary">Нууц үг:</Text>{" "}
                  <Text strong copyable>{response.initialPassword}</Text>
                </div>
              </div>
            </Space>
          ),
        });
        return;
      }

      const { sendWelcomeEmail, ...payload } = values;
      const response = await UpdateMerchant(merchant.id, payload);
      hideLoading();
      if (response?.success) {
        message.success("Амжилттай хадгалагдлаа");
        refresh?.();
        close();
      } else {
        message.error(response?.message || "Хадгалахад алдаа гарлаа");
      }
    } catch (error) {
      hideLoading();
      message.error(
        error.response?.data?.error?.message ||
          error.response?.data?.message ||
          error.message ||
          "Алдаа гарлаа"
      );
    }
  };

  return (
    <Modal
      title={isCreate ? "Шинэ мерчант бүртгэх" : "Мерчант мэдээлэл засах"}
      open={open}
      onCancel={close}
      footer={null}
      width={800}
      destroyOnClose
      styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <MerchantAdminFormFields mode={mode} />
        <div className="flex justify-end gap-2 pt-2">
          <Button onClick={close}>Болих</Button>
          <Button type="primary" htmlType="submit" className={bg_button}>
            {isCreate ? "Мерчант үүсгэх" : "Хадгалах"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AdminMerchantModal;
